module.exports = __webpack_public_path__ + "media/images/products/banners/carta_do_estrategista-746da2c48d2e0695ec8e90f873d3a97a.png";